__turbopack_context__.v({
  "categoryHeaderDetails": "uofnua_categoryHeaderDetails",
  "categoryWrapperDetails": "uofnua_categoryWrapperDetails",
  "listWrapperDetails": "uofnua_listWrapperDetails",
  "productsCountDetails": "uofnua_productsCountDetails",
});
